import React, { Component } from 'react';
import { connect } from 'react-redux';
import './../forms.css';
import * as repositoryActions from '../../../../Store/Actions/repositoryActions';
import TextBox from '../../TextBox/textbox';
import Button from '../../Button/button';

/*
PARAMETERS :
  create : true/false
  object : {} // object to update or null if create = true,
  reservedValue : {COLUMNNAME:[ARRAY OF RESERVED VALUE]}
*/
class T0C0Form extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
      create:true,
      endPoint:"EN3",
      blankObject:{
        AC_001: 0,
        ARCS: 0,
        ARCS_PER: 0,
        ARCS_TP_N3: 0,
        CODE: "",
        COMMENT: "",
        FLAG: 0,
        HISTORIQUE: 0,
        IU: "R",
        NSYS: 4,
        SIT: 0,
        Session: {},
        SessionIDE: "",
        Status: 0,
        WORDING: "",
      },
    };

  }

  // BUILDING METHOD DO NOT CHANGE
  componentDidMount = () =>{
    var node = this.props.node;
    
    // GET THE OBJECT IF ID is provided
    if(this.props.id > 0){
      this.props._get_single_object(this.props._sessionId,this.props.id,this.state.endPoint);
      this.setState({create:false});
    }else{
      // ELSE CREATE BLANK OBJECT AND TRIGGER ON CREATE
      var blankObject = {...this.state.blankObject};
     
      blankObject.ARCS_TP_N3 = this.props._TDI.find(item=>item.CODE ===node.subType).ARCS;
      console.log("BLANK OBJECT",blankObject);
      this.setState({create:true}); 
      this.props._onCreateBlank(blankObject);
    }
  }


  // INNER METHOD 

  //GENERIC DO NOT CHANGE
  onClickCancel = () =>{
    this.props.onCancelForm();
  }

  // MAY CHANGE
  // ADD ALERT MANAGEMENT FOR UNIQUE REF
  onClickValid = () =>{
    var object = this.props._newObject;
    if(this.state.create){
      // CHECK RESERVED VALUE UNIQUE CODE
          if(this.props._dataSet.map(item=>item.CODE).includes(object.CODE)){
            alert("the value : "+object.CODE+ " should be unique and is already in use for column :"+"CODE");
          }else{
            this.props.onSave(object);
          }
    }else{
      this.props.onSave(object);
    }

  }

  //GENERIC DO NOT CHANGE
  onUpdateValue = (columnName,e) =>{
    var object = {...this.props._newObject};
    object[columnName] = e;
    this.props._onUpdateValue(columnName,e);
  }

  render() {
    var content = this.props._newObject !== null ?
      <div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (id : {this.state.create?0:this.props._newObject.ARCS})</span>
            <div className="section-status valid"></div>
          </div>
          <div className="section-body">
            <div className={!this.state.create ? "section-item column-2 readOnly": "section-item column-2"}>
            <label>Code</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:this.state.create?false:true, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"CODE")}
              value = {this.props._newObject !== undefined? this.props._newObject["CODE"]:""}
            />
          </div>
            <div className="section-item column-2">
              <label>Wording ({this.props._language})</label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"WORDING")}
                value = {this.props._newObject !== undefined? this.props._newObject["WORDING"]!==undefined?this.props._newObject["WORDING"]:"":""}
              />
            </div>
            <div className="section-item column-1">
            <label>Comment</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:false, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"COMMENT")}
              value = {this.props._newObject !== undefined?this.props._newObject["COMMENT"]:""}
            />
          </div>
          </div>
        </div>
        <div className="form-section">
          <div>
              <Button 
                preventMultipleClick={0} 
                config={
                  {
                    isEnabled:true,
                    icon:"check",
                    text:"save change",
                    color:null,
                    textAlign:"center",
                    bgcolor:null
                  }
                } 
                OnClickElement={this.onClickValid.bind(this)}
              />
            </div>
        </div>
      </div>
    :
    null
    ;
    return (
      <div className="form-container" >
      {content}
      </div>
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
      _newObject:state.apiReducer.newObject,
      _sessionId: state.apiReducer.sessionId,
      _dataSet:state.apiReducer.workingData,
      _language:state.appReducer.language,
      _TDI:state.apiReducer.TDI,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      _get_single_object: (sessionId,id,endPoint) =>dispatch(repositoryActions.get_single_object(sessionId,id,endPoint)),
      _onUpdateValue:(columnName,e)=>dispatch(repositoryActions.onUpdateValue(columnName,e)),
      _onCreateBlank:(object)=>dispatch(repositoryActions.onCreateBlank(object)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(T0C0Form);